import PropTypes from 'prop-types';

import RichText, { fragment } from '../../Core/RichText';

import { StyledContainer, Wrapper, LegalCard, LegalLink } from './styles';

const LegalArticles = ({ data }) => {
  if (!data) return null;

  const { elements } = data;

  if (!elements) return null;

  return (
    <StyledContainer>
      <Wrapper>
        {elements.map(
          ({ id, sectionContainerHeading, ctas, sectionSubheading }) => {
            return (
              <LegalCard key={id}>
                {sectionContainerHeading && (
                  <RichText document={sectionContainerHeading} />
                )}
                {sectionSubheading && <RichText document={sectionSubheading} />}
                <ul className="no-bullets">
                  {ctas.map(cta => {
                    if (cta.hideFrench === true) return null;
                    return (
                      <li key={cta.id}>
                        <LegalLink key={cta.id} data={cta}>
                          <RichText document={cta.label} options={fragment} />
                        </LegalLink>
                      </li>
                    );
                  })}
                </ul>
              </LegalCard>
            );
          },
        )}
      </Wrapper>
    </StyledContainer>
  );
};

LegalArticles.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default LegalArticles;
